import { createSlice } from '@reduxjs/toolkit'
import { 
  createUpdateLocation, 
  fetchLocationList, 
  deleteLocation,  } from '../actions/locationsAction'

export const locations = createSlice({
  name: 'locations',
  initialState: {
    locations: null,
    error: null,
    sortBy: null,
    isLoader: false,
    isRecordAdded: false,
    isRecordUpdated: false,
  },
  reducers: {
    userReset: state => {
      // state.locations= null;
      state.error = null;
    },
    resetPopup: state => {
      state.isLoader= false;
      state.isRecordAdded= false;
      state.isRecordUpdated= false;
      state.error=null;
    },
  },
  extraReducers: {
    [fetchLocationList.pending]: (state, payload) => {
      state.error=null;
      state.isLoader= true;
    },
    [fetchLocationList.fulfilled]: (state, {payload}) => {
      state.error=null;
     state.locations=payload?.data;
     state.isLoader=false;
    },
    [fetchLocationList.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader= false;
    },
    [createUpdateLocation.pending]: (state, payload) => {
      state.error=null;
      state.isRecordAdded=false;
      state.isRecordUpdated=false;
      state.isLoader= true;
    },
    [createUpdateLocation.fulfilled]: (state, {payload}) => {  
      state.error=null; 
      state.isRecordAdded=true;
      state.isRecordUpdated=true;
      state.isLoader= false;
    },
    [createUpdateLocation.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordAdded=false;
      state.isRecordUpdated=false;
      state.isLoader= false;
    },
    [deleteLocation.pending]: (state, payload) => {
      state.error=null;
      state.isRecordUpdated= false;
      state.isLoader= true;
    },
    [deleteLocation.fulfilled]: (state, {payload}) => {   
      state.error=null;
      state.isRecordUpdated= true;
      state.isLoader= false;
    },
    [deleteLocation.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordUpdated= false;
      state.isLoader= false;
    },
    
  }
})

// Action creators are generated for each case reducer function
export const { userReset, userSort, userSearch, resetPopup} = locations.actions

export default locations.reducer